var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-contractors-item"},[_vm._v(" "+_vm._s(_vm.crudStore.state.single)+" "),(_vm.isLoading)?_c('app-loader',{attrs:{"isCircle":"","isAbsolute":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }